module.exports = __webpack_public_path__ + "static/media/Breathlessness.49446449.png";